import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/chevron.svg';

export const IconChevron = createIconComponent(Icon);
